import * as React from 'react';
import { Router, Route, Switch } from 'dva/router';
import routerUtil from '../../../utils/routerUtil';
import { Redirect } from 'react-router';
import identity from '../../config/routerIdentityConfig';

/**
 * App Component|Router Component
 */
export class App extends React.Component<any, any> {
  render() {
    const { app }: any = this.props;
    const routerConfig = {
      '/': {
        identity: identity.common,
        component: routerUtil.dynamicWrapper(app, ['global', 'account', 'home'], () => import('../../../layouts/auth/AuthHeaderLayout'))
      },
      '/login': {
        identity: identity.common,
        component: routerUtil.dynamicWrapper(app, ['account'], () => import('../../views/account/Login'))
      }
    };

    const HeaderContentLayout = routerConfig['/'].component;
    const Login = routerConfig['/login'].component;

    return (
      <Router history={this.props.history}>
        <Switch>
          <Route path={'/login'} component={props => <Login routerConfig={routerConfig} {...props} />} />
          <Redirect exact={true} path="/" to="/login" />
          <Route path={'/'} component={props => <HeaderContentLayout routerConfig={routerConfig} {...props} />} />
        </Switch>
      </Router>
    );
  }
}

/**
 * Dva Model Router Component Register and Bind
 * Every Router must set the model and component bind
 * use webpack chunk code split, you can set the chunk like the below
 * *webpackChunkName:'home'*
 * @param param0
 */
export function RouterConfig({ history, app }: any) {
  return <App history={history} app={app} />;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/abs/spa/accountCenter/Router.tsx